








import Vue from 'vue';

interface Props {
  type: 'date' | 'time' | 'year';
  value: Date;
  disabled: boolean;
  dateOptions: {};
}

interface Data {
  dateTime: Date;
  timeOptions: {
    start: string; // '00:00'
    step: string; // '00:15'
    end: string; // '23:45'
  };
}

interface Methods {
  updateDateTime: (dateTime: Data['dateTime']) => void;
}

export default Vue.extend<Data, Methods, {}, Props>({
  props: {
    value: {},
    type: {},
    disabled: {},
    dateOptions: {}
  },
  data () {
    return {
      dateTime: this.value,
      timeOptions: {
        start: '00:00',
        step: '00:15',
        end: '23:45'
      }
    };
  },
  methods: {
    updateDateTime: function (dateTime) {
      this.$emit('input', dateTime);
      this.$emit('change');
    }
  }
});

